import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <div>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for doesn’t exist.</p>
        <button
          onClick={() => navigate("/log-in")}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            backgroundColor: "#0f1d55",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
